module.exports = __webpack_public_path__ + "img/CLVHelp5.f6c2e20a.png";